// Prevenir zoom con doble clic y rotación horizontal
document.addEventListener('DOMContentLoaded', function() {
    // Prevenir zoom con doble clic
    let lastTouchEnd = 0;
    document.addEventListener('touchend', function (event) {
        const now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);

    // Prevenir zoom con gestos de pellizco
    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });

    document.addEventListener('gesturechange', function (e) {
        e.preventDefault();
    });

    document.addEventListener('gestureend', function (e) {
        e.preventDefault();
    });

    // Forzar orientación vertical
    function lockOrientation() {
        if (screen.orientation && screen.orientation.lock) {
            screen.orientation.lock('portrait').catch(function(error) {
                // Solo loguear si NO es NotSupportedError (que es esperado en muchos dispositivos)
                if (error.name !== 'NotSupportedError') {
                    console.warn('No se pudo bloquear la orientación:', error);
                }
                // NotSupportedError es normal en algunos dispositivos, no es necesario loguearlo
            });
        }
    }

    // Intentar bloquear la orientación cuando se carga la página
    lockOrientation();

    // Intentar bloquear la orientación cuando cambia
    if (screen.orientation) {
        screen.orientation.addEventListener('change', function() {
            if (screen.orientation.type.includes('landscape')) {
                lockOrientation();
            }
        });
    }

    // Prevenir zoom con la rueda del mouse
    document.addEventListener('wheel', function(e) {
        if (e.ctrlKey) {
            e.preventDefault();
        }
    }, { passive: false });

    // Prevenir zoom con Ctrl + scroll
    document.addEventListener('keydown', function(e) {
        if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
            e.preventDefault();
        }
    });
});

// Prevenir zoom en elementos específicos
function preventZoom(element) {
    element.addEventListener('touchstart', function(e) {
        if (e.touches.length > 1) {
            e.preventDefault();
        }
    }, { passive: false });

    element.addEventListener('touchend', function(e) {
        const now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            e.preventDefault();
        }
        lastTouchEnd = now;
    }, { passive: false });
}
